import React, {useEffect} from 'react'
import { CasoGeneralComponent } from 'defcol-caso-general'

import { useLocation } from 'react-router-dom'
import { obtenerDatosLlaves } from '../../store/actions/encargado-compania-action'
import { useDispatch } from 'react-redux'
import ConfirmarIngreso from './confirmarIngreso'

import { Card, Container } from 'react-bootstrap'

const ConfirmarIngresoRecobro = () => { 
  
    const {state}=useLocation()
    const idCasoLocation=state?.row?.IdCaso ? state.row.IdCaso:47;
    const idImplicado=state?.row?.IdImplicado ? state.row.IdImplicado :1;
    const idOrganizacionCaso =state?.row?.idOrganizacionCaso  ? state.row.idOrganizacionCaso:8600399880;
    const dispatch = useDispatch()


    useEffect(()=>{
        
        dispatch(obtenerDatosLlaves({idCaso:idCasoLocation, idImplicado:idImplicado,idOrgCaso:idOrganizacionCaso}))

    },[dispatch])
  
   
    
    
    return (
        <div> 
             
             <Container>
            <Card className='mt-2'>
                <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >{`Confirmar Rendición de Recobro - Caso ${idCasoLocation}`}</Card.Header>
                <Card.Body>
                    <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} />
                </Card.Body>
            </Card>
            </Container> 
            <ConfirmarIngreso />
        </div>
    )
}

export default ConfirmarIngresoRecobro
